module.exports = __webpack_public_path__ + "img/MongoDB_Logo_FullColorBlack_RGB-4td3yuxzjs-min.65f2bb87.png";